import { PageHeader } from '@/shared/ui';
import { Navigate } from 'react-router-dom';
import { useSettingsSections } from '../hooks';
import { CallNumbersPage } from '@/modules/calls/pages/CallNumbersPage';
import { ConnectionsPage, CredentialsPage } from '@/modules/insuranceVerification/pages';
import { OryxIntegration } from '@/modules/reviews/sms/OryxIntegration';
import { SettingsGroup, SettingsNote } from '../components/SettingsFrame';
import styles from './SettingsPage.module.css';

/**
 * Settings > Operations: one sub-section per area under Operations that is switched on for the practice. Calls'
 * tracking numbers; Insurance Verification's practice credentials and connections; the practice management system
 * (Oryx) that feeds text review requests. The day-to-day pages (Call Log,
 * Sources, Agents, the worklist) stay in the main menu.
 */
export function OperationsSettingsPage() {
  const sections = useSettingsSections();
  const callsEnabled = sections.calls;
  const insuranceEnabled = sections.insurance;
  const pmsEnabled = sections.practiceManagement;
  // Neither module is on for this practice: there is nothing here (the menu does not offer it either).
  if (sections.loading) return null;
  if (!sections.operations) return <Navigate to="/settings/practice" replace />;
  return (
    <div className={styles.page}>
      <PageHeader
        title="Operations Settings"
        subtitle="Settings for everything under Operations."
      />
      {callsEnabled && (
        <SettingsGroup id="settings-calls" title="Calls">
          <CallNumbersPage embedded level={3} />
          <SettingsNote>
            Also listed in Communication Settings › Call Settings, with any other numbers the
            practice uses.
          </SettingsNote>
        </SettingsGroup>
      )}
      {insuranceEnabled && (
        <SettingsGroup id="settings-insurance" title="Insurance Verification">
          <CredentialsPage embedded level={3} />
          <ConnectionsPage embedded level={3} />
        </SettingsGroup>
      )}
      {pmsEnabled && (
        <SettingsGroup id="settings-pms" title="Practice management system">
          <OryxIntegration />
          <SettingsNote>
            Connect the Oryx account of the location selected at the top. Each location has its own
            login.
          </SettingsNote>
        </SettingsGroup>
      )}
    </div>
  );
}
